import Vue from 'vue';

// Global Components
Vue.component('checkbox', require('./components/CheckboxControl.vue').default);
Vue.component('custom-input', require('./components/CustomInputControl.vue').default);
Vue.component('help-icon', require('./components/HelpIconControl.vue').default);
Vue.component('slider', require('./components/SliderControl.vue').default);
Vue.component('animated-number', require('./components/AnimatedNumberControl.vue').default);

// Page components
Vue.component('about-personal', require('./pages/about/Personal.vue').default);
Vue.component('about-retirement', require('./pages/about/Retirement.vue').default);
Vue.component('about-super', require('./pages/about/Super.vue').default);
